// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__i8Z-E","input":"Radio_input__q3YID","fake":"Radio_fake__FjUiW","label":"Radio_label__FLsPK"};